import React, { useState, useContext } from "react";
import "./SideBar.css";
import { OrderContext } from "../../contexts/OrderContext";
import CartIcon from "../layout/CartIcon";
import ScheduleCalendar from "./ScheduleCalendar";
import { MEDIA_URL } from "../../utils/constants";
import { convertISOToDateString } from "../../utils/utils";

function OrderedProduct({props}) {
  const { addItem, removeItem } = useContext(OrderContext);
  const [quantity, setQuantity] = useState(props.quantity);

  const handleQuantityChange = (e) => {
    const newQuantity = parseInt(e.target.value, 10);
    setQuantity(newQuantity);

    if (newQuantity > 0) {
      addItem(props, newQuantity);
    } else {
      removeItem(props.id);
    }
  };

  return (
    <li className="cart-product-item">
      <div className="cart-product-div">
        <div className="cart-product-image">
          <img src={MEDIA_URL + props.image} alt={props.name} loading="lazy" />
        </div>
        <div className="cart-product-info">
          <h3>{props.name}</h3>
          <p>{props.description}</p>
          <div className="cart-ordering">
            {/* <h3>${props.price}</h3> */}
            <input
              type="number"
              min="0"
              value={quantity}
              pattern="[0-9]+"
              onChange={handleQuantityChange}
            />
          </div>
        </div>
        <span className="material-symbols-outlined" onClick={() => removeItem(props.id)}>
          delete
        </span>
      </div>
    </li>
  )
}

function SideBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { cartItems, date, location, confirmOrder, stage, setStage } = useContext(OrderContext);

  const handleConfirmOrder = async () => {
    setLoading(true);
    const response = await confirmOrder();
    setLoading(false);
    setIsOpen(!response);
  }

  return (
    <div>
      <span className="span-space" />
      <CartIcon opener={setIsOpen} />
      {isOpen &&
      <div className="sidenav-container">
        <span className="material-symbols-outlined" onClick={() => setIsOpen(!isOpen)}>
          keyboard_double_arrow_right
        </span>
        {stage === 0 &&
        <>
          <h2>
            Orden
          </h2>
          {cartItems.length ?
            <>
            <ul className="cart-items-list">
              {cartItems.map((item) => (
                <OrderedProduct props={item} />
              ))}
            </ul>
            <div className="cart-total">
              <hr />
              {/* <h3>Total: ${totalAmount.toFixed(2)}</h3> */}
              <button className="common-button" type="submit" onClick={() => setStage(1)}>
                Elegir fecha {'>'}
              </button>
            </div>
            </> :
            <p style={{margin:"15px"}}>El carrito esta vacío</p>
          }
        </>}
        {stage === 1 &&
        <>
          <ScheduleCalendar />
        </>}
        {stage === 2 &&
        <>
        <div className="cart-confirmation">
          <div className="cart-confirmation-header">
            <span className="material-symbols-outlined" onClick={() => setStage(1)}>
              arrow_back
            </span>
            <h2>Confirmar compra</h2>
          </div>
          <div className="cart-summary">
            <div className="cart-summary-section">
              <h3>Productos</h3>
              <ul>
                {cartItems.map((item, index) => (
                  <li key={index} className="cart-summary-item">
                    <span>{item.name + " " + item.description}</span>
                    <span>x{item.quantity}</span>
                    {/* <span>${(item.price * item.quantity).toFixed(2)}</span> */}
                  </li>
                ))}
              </ul>
            </div>
            <div className="cart-summary-section">
              <h3>Detalles de entrega</h3>
              <p><strong>Fecha:</strong> {convertISOToDateString(date)}</p>
              <p><strong>Ubicación:</strong> {location || 'A definir'}</p>
            </div>
            <div className="cart-total">
              <hr />
              {/* <h3>Total: ${totalAmount.toFixed(2)}</h3> */}
              <button
                className="common-button"
                type="submit"
                disabled={loading}
                onClick={() => handleConfirmOrder()}>
                {loading ? 'Realizando pedido...' : 'Realizar pedido'}
              </button>
            </div>
          </div>
        </div>
        </>}
      </div>}
    </div>
  )
}

export default SideBar;